<template>
    <ul class="nav">
        <li  @click="class_change" :class="this.active==1?'active':''"><router-link to="/Home" data-c="1">网站首页</router-link></li>
        <li  @click="class_change" :class="this.active==2?'active':''"><router-link to="/About" data-c="2">关于我们</router-link></li>
        <li  @click="class_change" :class="this.active==3?'active':''"><router-link to="/Show" data-c="3">产品展示</router-link></li>
        <li  @click="class_change" :class="this.active==4?'active':''"><router-link to="/Project" data-c="4">产品配套方案</router-link></li>
        <li  @click="class_change" :class="this.active==5?'active':''"><router-link to="/Service" data-c="5">项目承揽与服务</router-link></li>
        <li  @click="class_change" :class="this.active==6?'active':''"><router-link to="/Information" data-c="6">资讯公告</router-link></li>
        <li  @click="class_change" :class="this.active==7?'active':''"><router-link to="/Contact" data-c="7">联系我们</router-link></li>
    </ul>
</template>

<script>
export default {
    data() {
    return {
        active: '1' 
    };
  },
    methods:{
        class_change(e){
            this.active = e.target.getAttribute('data-c')
        }
    }
}
</script>

<style scoped> 
.nav{
    display: flex;
    justify-content: center;
     background-color: rgb(0, 104, 172);/*rgb(75, 179, 68) rgb(204, 204, 204, 1)*/
    min-width: 1200px;
}
ul li{
    width: 200px;
    height: 40px;
    line-height: 40px;
    text-align: center;
}
ul li a{
    display: block;
    width: 100%;
    height: 100%;
    color: white;
}
ul li:hover{
    background-color: rgb(93, 203, 246);
}
.active{
    background-color: rgb(93, 203, 246);
}
</style>


// WEBPACK FOOTER //
// src/components/Nav.vue